import './style.css';
import EkycJourney from "./EkycJourney";
import {isMobile} from "../../oss/site";

$(document).ready(function () {

    const startEkycJourney = async function (btn) {

        const wrapper = btn.closest('.ooredoo-ekyc-wrapper');
        // const btn = $(this);
        let formFields = wrapper.find('template.ooredoo-ekyc__fields').html().trim();

        let formConfig = wrapper.find('.ooredoo-ekyc-config').html().trim();

        formConfig = atob(formConfig);
        formConfig = JSON.parse(formConfig);

        if (!isMobile() && true !== formConfig.active_on_desktop) {
            $.alert({
                content: formConfig.unavailable_desktop_message,
                columnClass: 'column is-6',
                iconHtml: null,
                icon: 'icon-Icon-161',
                // hideIcon: true,
                jqueryConfirmClasses: 'ekyc-modal ekyc-modal-data-capture',
                onBeforeOpenCallback: function () {

                },
                onContentReady: function () {

                },
                onClose: function () {

                },

                buttons: {
                    close: {
                        text: window.application.ods.js_trans.close,
                    },

                }

            })

            return;
        }

        // if (!btn.find('.btn--loader').length) {
        //     btn.append(btnLoaderTemplate);
        // }
        //
        // btn.addClass('is-loading');

        const disableLivenessCheck = parseInt(wrapper.attr('data-disable_liveness_check'), 10) === 1;

        const _ekycJourney = new EkycJourney(formConfig, {
            form: btn.closest('form'),
            btn: btn,
            disable_liveness_check: disableLivenessCheck,
            wrapper: wrapper,
            onDataCaptureSuccess: function (dataCaptureState) {

                console.log('onDataCaptureSuccess', dataCaptureState);

                const form = btn.closest('form');

                let ekycIdInput = form.find('[name="ekyc_id"]');
                if (!ekycIdInput.length) {
                    ekycIdInput = $('<input type="hidden" name="ekyc_id" />');
                    form.append(ekycIdInput);
                }

                ekycIdInput.val(dataCaptureState.data_captrue.ocr_id);

                form.find('[name="first_name"]').val(dataCaptureState.data_captrue.info.firstName);
                form.find('[name="second_name"]').val(dataCaptureState.data_captrue.info.secondName);
                form.find('[name="middle_name"]').val(dataCaptureState.data_captrue.info.thirdName);
                form.find('[name="last_name"]').val(dataCaptureState.data_captrue.info.familyName);

                form.find('[name="contact_name"]').val(dataCaptureState.data_captrue.info.fullName);

                form.find('[name="identity_no"]').val(dataCaptureState.data_captrue.info.iDNumber);
                form.find('[name="identity_id"]').val(dataCaptureState.data_captrue.info.iDNumber);

                // "1989-12-09"
                form.find('[name="date_of_birth"]').val(dataCaptureState.data_captrue.info.dateOfBirth);


                const img = form.find('.lego-browse[data-name="image"]');
                if (img.length) {
                    img.data('_lgeo_upload').renderView(img, img.data('_lgeo_upload').options, dataCaptureState.data_captrue.file)
                }

                const imgAttachment = form.find('.lego-browse[data-name="attachment"]');
                if (imgAttachment.length) {
                    imgAttachment.data('_lgeo_upload').renderView(imgAttachment, imgAttachment.data('_lgeo_upload').options, dataCaptureState.data_captrue.file)
                }

                wrapper.attr('data-ekyc_active_action', 'replace');
                btn.attr('data-ekyc_action', 'replace');
                btn.find('.ekyc-btn-text').text(wrapper.data('ekyc_text_replace'));



            },

            onLivenessCheckSuccess: function (dataCaptureState) {
                console.log('onLivenessCheckSuccess', dataCaptureState);
            },

            onJourneyCompleted() {
                console.log('onJourneyCompleted')
            }

        });


        // console.log('btn.attr(\'ekyc_step\')',btn,btn.attr('data-ekyc_step'))
        //
        // if(btn.attr('data-ekyc_step') == 'liveness'){
        //
        //     _ekycJourney.initListeners();
        //     _ekycJourney.startLivenessCheck();
        //
        //     return;
        // }

        _ekycJourney.startJourney();

    };

    $('body').on('click', '[data-ekyc_action="capture"]', function (e) {
        startEkycJourney($(this));
    });

    $('body').on('click', '[data-ekyc_action="replace"]', function (e) {
        startEkycJourney($(this));

    });

});
